import { Range, Editor, Transforms, Text, Path, Node } from 'slate';
import { Type, isHeading } from '../HeadingPlugin.mjs';
import { isElement } from '../../../../../core/utilities/nodes/elements/isElement.mjs';
import { isInline } from '../../../../../core/queries/isInline.mjs';

function setHeading(editor, headingLevel, defaultBlockType) {
  let at = editor.selection;
  if (Range.isRange(at)) {
    at = Editor.unhangRange(editor, at);
  }
  if (!at) {
    return;
  }
  const matchSameTextBlock = node => {
    if (isHeading(node)) {
      return node.level === headingLevel;
    }
    if (isElement(node) && node.type === defaultBlockType) {
      return headingLevel === null;
    }
    return false;
  };
  const matchTextBlockElement = node => isElement(node) && (node.type === Type || node.type === defaultBlockType);
  const matchBlockLeafAncestor = node => {
    if (isElement(node) && !isInline(editor, node) && node.children.some(child => !isElement(child))) {
      return true;
    }
    return false;
  };
  const hasElementParent = path => {
    const parentPath = Path.parent(path);
    const parent = Node.get(editor, parentPath);
    return isElement(parent);
  };
  const futureHeadings = Array.from(Editor.nodes(editor, {
    at,
    match: node => {
      if (matchSameTextBlock(node)) {
        return false;
      }
      return true;
    }
  }));
  const futureHeadingRefs = futureHeadings.map(([node, path]) => ({
    node,
    pathRef: Editor.pathRef(editor, path)
  }));
  Editor.withoutNormalizing(editor, () => {
    futureHeadingRefs.forEach(({
      node,
      pathRef
    }) => {
      if (pathRef.current) {
        if (matchTextBlockElement(node)) {
          if (!headingLevel && hasElementParent(pathRef.current)) {
            // If the going to default block type and the heading is a child of an element, unwrap the heading
            Transforms.unwrapNodes(editor, {
              at: pathRef.current
            });
          } else if (!headingLevel) {
            Transforms.setNodes(editor, {
              ...node,
              type: defaultBlockType
            }, {
              at: pathRef.current
            });
            Transforms.unsetNodes(editor, 'level', {
              at: pathRef.current
            });
          } else {
            // all other cases of matching a text block element, update the node
            Transforms.setNodes(editor, createHeadingElement(headingLevel), {
              at: pathRef.current
            });
          }
        } else if (headingLevel && matchBlockLeafAncestor(node)) {
          // if the node is a leaf ancestor, block level and not a text block, wrap all it's child text nodes in a heading
          Transforms.wrapNodes(editor, createHeadingElement(headingLevel), {
            at: pathRef.current,
            match: node => Text.isText(node)
          });
        }
      }
      pathRef.unref();
    });
  });
}
function createHeadingElement(level) {
  return {
    type: Type,
    level
  };
}

export { setHeading };
